import React, { FC, Fragment } from 'react';
import BEMHelper from '@ynap/bem-helper';
import { CombinedSelect } from '@ynap/select';
import Flag from '@ynap/flag';
import { Field as FormField, FieldRenderProps } from '@ynap/form';
import { ValidatedField } from '@ynap/field';
import { Field, Messages } from './@types';
import { getSearchedCountries, validate } from './utils';

const afBem = new BEMHelper('AddressForm');

interface CountrySelectFieldProps {
    innerKey: string;
    className: string;
    field: Field;
    messages?: Messages;
    help?: string;
    errorStyle?: string;
    initialValue?: string;
}

export const CountrySelectField: FC<CountrySelectFieldProps> = ({ innerKey, className, field, initialValue, messages, help, errorStyle = 'error' }) => {
    const { wcsType, values } = field;
    const name = (wcsType?.name || 'country').toString();
    let displayName =
        messages && messages.addressForm && messages.addressForm.display && messages.addressForm.display.country
            ? messages.addressForm.display.country()
            : 'Country';
    let selectLabel = messages && messages.addressForm && messages.addressForm.select ? messages.addressForm.select({ select: displayName }) : 'Select country';

    const options = values
        ? values
              .sort((a, b) => (typeof a !== 'string' && typeof b !== 'string' ? (a.display < b.display ? -1 : 1) : a < b ? -1 : 1))
              .map((option) => {
                  const display = typeof option !== 'string' ? option.display : option;
                  const value = typeof option !== 'string' ? option.value : option;
                  return {
                      key: value,
                      value,
                      label: (
                          <Fragment>
                              <Flag countryISO={value.toUpperCase()} />
                              <span className={afBem('flagLabel')}>{display}</span>
                          </Fragment>
                      ),
                      labelNative: display,
                  };
              })
        : [];

    return (
        <FormField key={innerKey} name={name} value={initialValue || ''} validate={validate(messages, field, displayName)}>
            {({ value, onChange, onBlur, errors, touched }: FieldRenderProps) => {
                const error = touched && errors && errors[0] ? errors[0] : undefined;
                return (
                    <ValidatedField label={displayName} htmlFor={name} error={error} className={className} help={help} errorStyle={errorStyle}>
                        <div>
                            <CombinedSelect
                                value={value}
                                onChange={(value: string) => {
                                    onChange(value);
                                    onBlur(value);
                                }}
                                onDropdown={() => onBlur(value)}
                                emptyLabel={selectLabel}
                                options={options}
                                key={name}
                                id={name}
                                enableSearch={true}
                                searchFilter={getSearchedCountries}
                                searchPlaceholder={messages?.addressForm?.search?.()}
                            />
                        </div>
                    </ValidatedField>
                );
            }}
        </FormField>
    );
};
